export const profileOptions = {
  en: {
    slovenia: 'Slovenia',
    croatia: 'Croatia',
    austria: 'Austria',
    germany: 'Germany',
    italy: 'Italy',
    england: "England",

    slovenian: "Slovenian",
    english: "English",

    ljubljanaTimeZone: 'Ljubljana (GMT+1 / GMT+2)',
    londonTimeZone: 'London (GMT+0 / GMT+1)',
    berlinTimeZone: 'Berlin (GMT+1 / GMT+2)',
    newYorkTimeZone: 'New York (GMT-5 / GMT-4)',
    tokyoTimeZone: 'Tokyo (GMT+9)',
  },
  sl: {
    slovenia: 'Slovenija',
    croatia: 'Hrvaška',
    austria: 'Avstrija',
    germany: 'Nemčija',
    italy: 'Italija',
    england: "Anglija",

    slovenian: "Slovenščina",
    english: "Angleščina",

    ljubljanaTimeZone: 'Ljubljana (GMT+1 / GMT+2)',
    londonTimeZone: 'London (GMT+0 / GMT+1)',
    berlinTimeZone: 'Berlin (GMT+1 / GMT+2)',
    newYorkTimeZone: 'New York (GMT-5 / GMT-4)',
    tokyoTimeZone: 'Tokio (GMT+9)',
  },
};